export default __webpack_public_path__ + "static/media/tracks-top.09b603f6.svg";